import React from 'react';

const DescriptionField = ({ value, onChange, enhanceWithAi, onEnhanceWithAiChange }) => {
  return (
    <div className="form-group">
      <label htmlFor="description" className="form-label">Agent Description</label>
      
      {/* Enhance with AI checkbox - clearly noticeable */}
      <div className="form-group" style={{ marginBottom: '10px', padding: '10px', backgroundColor: '#f8f9fa', border: '1px solid #dee2e6', borderRadius: '4px' }}>
        <label className="checkbox-label" style={{ fontWeight: 'bold', color: '#495057' }}>
          <input
            type="checkbox"
            checked={enhanceWithAi}
            onChange={onEnhanceWithAiChange}
            style={{ marginRight: '8px' }}
          />
          ✨ Enhance with AI
        </label>
        <div className="form-help-text" style={{ fontSize: '0.875rem', color: '#6c757d', marginTop: '4px' }}>
          When enabled, AI will transform your description into an optimized conversational flow.
        </div>
      </div>
      
      <textarea
        id="description"
        name="description"
        value={value}
        onChange={onChange}
        className="form-control description-textarea"
        placeholder="Enter detailed instructions for the agent..."
        rows="5"
        required
      />
      <small className="form-text text-muted">
        Describe what the agent should do and how it should interact with users.
        This will be used as the system prompt for the agent.
      </small>
    </div>
  );
};

export default DescriptionField;
